import { observer } from 'mobx-react';
import { FC, ReactNode, useEffect } from 'react';

import { provide, useDependencies } from '@servicetitan/react-ioc';
import { useFlag, FeatureFlags } from '@servicetitan/standalone-feature-flags';

import { FeaturesStore } from '../stores/features.store';

export const Features: FC<{ children: ReactNode }> = provide({ singletons: [FeaturesStore] })(
    observer(({ children }) => {
        const [{ setFeatureFlagValues }] = useDependencies(FeaturesStore);

        const { value: isSMSRegistrationEnabled } = useFlag(
            FeatureFlags.SmsRegistrationSettings,
            false,
        );
        const { value: isSmsRegistrationSettingsStandaloneDisabled } = useFlag(
            FeatureFlags.DisableSmsRegistrationSettingsStandalone,
            false,
        );

        const { value: isCustomizableAttributionWindowEnabled } = useFlag(
            FeatureFlags.CustomizableAttributionWindow,
            false,
        );

        const { value: isCustomizableCustomFieldsEnabled } = useFlag(
            FeatureFlags.CustomizableCustomFields,
            false,
        );

        const { value: isAnalyticsDataExportsEnabled } = useFlag('analytics-data-exports', false);

        const { value: isCampaignManagementAutopilotIntegrationEnabled } = useFlag(
            FeatureFlags.CampaignManagementAutopilotIntegrationEnabled,
            false,
        );

        useEffect(() => {
            setFeatureFlagValues({
                isSMSRegistrationEnabled,
                isSmsRegistrationSettingsStandaloneDisabled,
                isCustomizableAttributionWindowEnabled,
                isCustomizableCustomFieldsEnabled,
                isAnalyticsDataExportsEnabled,
                isCampaignManagementAutopilotIntegrationEnabled,
            });
        }, [
            isSMSRegistrationEnabled,
            isSmsRegistrationSettingsStandaloneDisabled,
            isCustomizableAttributionWindowEnabled,
            isCustomizableCustomFieldsEnabled,
            isAnalyticsDataExportsEnabled,
            isCampaignManagementAutopilotIntegrationEnabled,
            setFeatureFlagValues,
        ]);

        return children;
    }),
);
